export const getClubName = (clubName: string) => {
  if (clubName === "Kontraktslös") return "Kontraktslösa";
  if (clubName === "Kontraktslös (Damer)") return "Kontraktslösa (Damer)";

  return clubName;
};
